const BaseView = require('./abstract-type');
const template = require('./table-type.hbs');

module.exports = BaseView.extend({
  type: 'table',
  colorType: {
    table: 'table_object_color',
    text: 'table_text_color'
  },

  toggleSectionEvent: function (event) {
    const option = event.currentTarget;

    this._addDefaultColor(option);
    this._toggleSectionDisabled(option);
    this.recalculateSectionHeight(option);

    BaseView.prototype.toggleSectionEvent.apply(this, arguments);
  },

  _addDefaultColor: function (option) {
    const id = option.id;
    const type = id && id.replace('element-restrictions-', '').replace('-colors-library', '').replace('-colors', '');

    if (id === `element-restrictions-${type}-colors`) {
      const colorsLibrary = this.el.querySelector(`#element-restrictions-${type}-colors-library`);

      this[`${type}colorsListView`].getData().length || this[`${type}colorsListView`].addElement('#000000');
      colorsLibrary.checked = false;
      this._toggleSectionDisabled(colorsLibrary);
      this.onSectionChange(colorsLibrary);
    } else if (id === `element-restrictions-${type}-colors-library`) {
      const colors = this.el.querySelector(`#element-restrictions-${type}-colors`);

      this[`${type}colorsLibraryView`].setLibraryPaletteRestriction({ palette: 0 });
      colors.checked = false;
      this._toggleSectionDisabled(colors);
      this.onSectionChange(colors);
    }
  },

  _toggleSectionDisabled: function (option) {
    const sectionName = option.closest('.restrictions.group').getAttribute('data-name') || 'basic';
    const name = option.getAttribute('name') || option.closest('.restrictions.group[data-field]')?.getAttribute('data-field');
    const value = this.getOptionValue($(option));

    sectionName === 'basic'
      ? this._toggleBasicSectionDisabled(name, value)
      : this._toggleColorSectionDisabled(sectionName, value);
  },

  _toggleBasicSectionDisabled: function (name, value) {
    name === 'table_object_color' && this._toggleColors('table', value);
    name === 'table_text_color' && this._toggleColors('text', value);
  },

  _toggleColorSectionDisabled: function (sectionName, value) {
    const type = sectionName.replace('colors-library', '').replace('colors', '');

    if (sectionName.includes('colors-library')) {
      this.el.querySelector(`.${type}-palette-replacement-options`).classList.toggle('hidden', !value);
    } else if (sectionName.includes('colors')) {
      this.el.querySelector(`.${type}-color-replacement-options`).classList.toggle('hidden', !value);
      value || this[`${type}colorsListView`].removeAllElement();
    }
  },

  _toggleColors: function (type, value) {
    const colors = this.el.querySelector(`#element-restrictions-${type}-colors`);
    const colorsLibrary = this.el.querySelector(`#element-restrictions-${type}-colors-library`);

    this.el.querySelector(`div[data-name="${type}colors"]`).classList.toggle('hidden', !value);
    this.el.querySelector(`div[data-name="${type}colors-library"]`).classList.toggle('hidden', !value);

    if (value) return;

    const previousColorsChecked = colors.checked;
    const previousColorsLibraryChecked = colorsLibrary.checked;

    this.el.querySelector(`.${type}-color-replacement-options`).classList.toggle('hidden', true);
    this.el.querySelector(`.${type}-palette-replacement-options`).classList.toggle('hidden', true);
    colors.checked = false;
    colorsLibrary.checked = false;
    this[`${type}colorsListView`].removeAllElement();
    previousColorsChecked && this.onSectionChange(colors);
    previousColorsLibraryChecked && this.onSectionChange(colorsLibrary);
  },

  _renderRestrictions: function (restrictions, sectionName) {
    if (sectionName === 'tablecolors' && restrictions[sectionName]) {
      _(restrictions[sectionName].list).each(this.tablecolorsListView.addElement);
    }

    if (sectionName === 'tablecolors-library' && restrictions[sectionName]) {
      this.tablecolorsLibraryView.setLibraryPaletteRestriction(restrictions[sectionName]);
    }

    if (sectionName === 'textcolors' && restrictions[sectionName]) {
      _(restrictions[sectionName].list).each(this.textcolorsListView.addElement);
    }

    if (sectionName === 'textcolors-library' && restrictions[sectionName]) {
      this.textcolorsLibraryView.setLibraryPaletteRestriction(restrictions[sectionName]);
    }

    return BaseView.prototype._renderRestrictions.apply(this, arguments);
  },

  getOptionValue: function ($option) {
    if ($option.is('.element-list') && $option.data('uuid') === 'tablecolor') {
      return this.tablecolorsListView.getData();
    }

    if ($option.is('.element-list') && $option.data('uuid') === 'textcolor') {
      return this.textcolorsListView.getData();
    }

    return BaseView.prototype.getOptionValue.apply(this, arguments);
  },

  getPermissionObject: function (key) {
    if (key.indexOf('custom') > -1) {
      return {
        name: key, is_custom: true, is_color: key.indexOf('color') > -1, is_separator: key.indexOf('separator') > -1
      };
    }
    return { name: key, tag: 'tool.restrictions.template.permission.' + key };
  },

  renderDisabled: function () {
    this._renderColorDisabled('table');
    this._renderColorDisabled('text');
  },

  _renderColorDisabled: function (type) {
    const replaceColorInput = document.querySelector(`#element-restrictions-${this.colorType[type]}`);
    const replaceColorSubInput = document.querySelector(`#element-restrictions-${type}-colors`);
    const replaceColorPaletteSubInput = document.querySelector(`#element-restrictions-${type}-colors-library`);
    const isReplaceOn = this.getOptionValue($(replaceColorInput));
    const isReplaceSpecifiedColorOn = this.getOptionValue($(replaceColorSubInput));
    const isReplaceSpecifiedPaletteOn = this.getOptionValue($(replaceColorPaletteSubInput));

    if (replaceColorInput) {
      this.el.querySelector(`div[data-name="${type}colors"]`).classList.toggle('hidden', !isReplaceOn);
      this.el.querySelector(`div[data-name="${type}colors-library"]`).classList.toggle('hidden', !isReplaceOn);

      if (replaceColorSubInput) {
        this.el.querySelector(`.${type}-color-replacement-options`).classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedColorOn));
      }

      if (replaceColorPaletteSubInput) {
        this.el.querySelector(`.${type}-palette-replacement-options`).classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedPaletteOn));
      }
    }
  },

  render: function () {
    const basicPermissions = [
      'table_position',
      'table_size',
      'table_rotation',
      'table_duplication',
      'table_deletion'
    ].map(this.getPermissionObject);

    const tablePermissions = [
      'table_text_style',
      'custom_separator',
      'table_object_style',
      'custom_text_color',
      'table_row_column',
      'table_merge_split',
      'table_resize',
      'table_opacity'
    ].map(this.getPermissionObject);

    this.$el.html(template({ basicPermissions, tablePermissions }));

    this.initColorsList('table');
    this.initLibraryColors('table');
    this.initColorsList('text');
    this.initLibraryColors('text');

    this.renderRestrictions();
    this.renderDisabled();
  }
});
